export default __webpack_public_path__ + "static/media/payments-default.fc5eb1ed.svg";